// extracted by mini-css-extract-plugin
export default {"main":"EnglishPet_main__zFrYZ","course_name":"EnglishPet_course_name__VHD3R"};